// Generated from OpenAPI spec - Backend API types
// Auto-generated to match openapi-spec.json

// Enums
export enum AccountStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended'
}

export enum UserRole {
  Admin = 'Admin',
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended'
}

export enum EnvironmentStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Maintenance = 'Maintenance'
}

export enum EnvironmentType {
  Development = 'Development',
  Uat = 'Uat',
  Staging = 'Staging',
  Production = 'Production'
}

export enum DeploymentStatus {
  Deploying = 'Deploying',
  Deployed = 'Deployed',
  Failed = 'Failed',
  Rollback = 'Rollback'
}

export enum ServiceStatus {
  Healthy = 'Healthy',
  Warning = 'Warning',
  Error = 'Error',
  Maintenance = 'Maintenance'
}

export enum ServiceType {
  Api = 'Api',
  Microservice = 'Microservice',
  Library = 'Library',
  Database = 'Database',
  Frontend = 'Frontend'
}

// Service Health Status (from monitoring system)
export enum ServiceHealthStatus {
  Unknown = 'Unknown',
  Healthy = 'Healthy',
  Degraded = 'Degraded',
  Unhealthy = 'Unhealthy',
  Timeout = 'Timeout',
  DnsFailure = 'DnsFailure',
  ConnectionFailure = 'ConnectionFailure',
  SslFailure = 'SslFailure'
}

export enum ServiceMonitoringAuthType {
  None = 'None',
  Bearer = 'Bearer',
  ApiKey = 'ApiKey',
  Basic = 'Basic',
  Custom = 'Custom'
}

export enum HttpMethodType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS'
}

export enum TeamLinkType {
  Jira = 'Jira',
  Confluence = 'Confluence',
  Github = 'Github',
  Slack = 'Slack',
  Wiki = 'Wiki',
  Documentation = 'Documentation',
  Other = 'Other'
}

export enum BillingInterval {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually'
}

export enum SubscriptionStatus {
  Pending = 'Pending',
  Active = 'Active',
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  PastDue = 'PastDue',
  Suspended = 'Suspended'
}

export enum IncidentSeverity {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Critical = 'Critical'
}

export enum IncidentStatus {
  Investigating = 'Investigating',
  Identified = 'Identified',
  Monitoring = 'Monitoring',
  Resolved = 'Resolved'
}

// Account Management
export interface AccountDto {
  id: string;
  name: string | null;
  companyName: string | null;
  email: string | null;
  phone: string | null;
  status: AccountStatus;
  referralCode: string;
  referredByCode: string | null;
  referralCount: number;
  usersCount: number;
  subscriptionsCount: number;
  onboardingCompleted?: boolean;
  customerCode: string | null;
  paystackCustomerCode: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAccountDto {
  name: string | null;
  companyName: string | null;
  email: string | null;
  phone: string | null;
  referredByCode?: string | null;
}

export interface UpdateAccountDto {
  name: string | null;
  companyName: string | null;
  email: string | null;
  phone: string | null;
  onboardingCompleted: boolean;
}

export interface UpdateReferralCodeDto {
  referralCode: string;
}

export interface GetUserAccountResponseDto {
  user: UserDto;
  account: AccountDto;
}

export interface UserAccountDto {
  accountId: string;
  companyName: string;
  role: string;
  department: string;
}

export interface GetUserAccountsResponseDto {
  userId: string;
  email: string;
  name: string;
  accounts: UserAccountDto[];
}

// User Management
export interface UserDto {
  id: string;
  name: string | null;
  email: string | null;
  avatar: string | null;
  identityId: string | null;
  lastActive: string;
  createdAt: string;
  updatedAt: string;
  role: UserRole;
  status: UserStatus;
  accountId: string | null;
  accountName: string | null;
  isLocked: boolean;
}

export interface InviteUserDto {
  email: string;
  name?: string | null;
  role: UserRole;
  department?: string | null;
}

export interface PendingInvitationDto {
  id: string;
  email: string;
  name?: string;
  accountId: string;
  role: UserRole;
  department: string;
  expiresAt: string;
  isAccepted: boolean;
  acceptedAt?: string;
  createdAt: string;
}

export interface UpdateUserDto {
  name: string | null;
  avatar: string | null;
  role: UserRole;
  status: UserStatus;
  department: string | null;
}

// Subscription Management
export interface SubscriptionDto {
  id: string;
  accountId: string;
  productOptionId: string;
  subscriptionCode: string | null;
  customerCode: string | null;
  authorizationCode: string | null;
  status: SubscriptionStatus;
  amount: number;
  currency: string | null;
  billingInterval: BillingInterval;
  startedOn: string;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelledOn: string | null;
  cancelAtPeriodEnd: boolean;
  scheduledStartDate: string | null;
  isScheduled: boolean;
  changeType: string | null;
  mostRecentInvoiceStatus: string | null;
  createdAt: string;
  updatedAt: string;
  accountName: string | null;
  productName: string | null;
  productOption: ProductOptionDto | null;
  isActive: boolean;
  daysUntilRenewal: number;
}

export interface CreateSubscriptionDto {
  planCode: string | null;
  amount: number;
  billingInterval: BillingInterval;
  callbackUrl: string | null;
}

export interface SubscriptionResponseDto {
  subscriptionId: string;
  authorizationUrl: string | null;
  requiresPayment: boolean;
  isDowngrade: boolean;
  scheduledStartDate: string | null;
  message: string;
}

// Products
export interface ProductDto {
  id: string;
  name: string | null;
  description: string | null;
  isActive: boolean;
  maxUsers: number;
  maxServices: number;
  maxTeams: number;
  features: string[] | null;
  options: ProductOptionDto[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface ProductOptionDto {
  id: string;
  productId: string;
  code: string | null;
  billingInterval: BillingInterval;
  price: number;
  currency: string | null;
  paystackPlanCode: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  displayName: string | null;
}

export interface CreateProductDto {
  name: string | null;
  description: string | null;
  maxUsers: number;
  maxServices: number;
  maxTeams: number;
  features: string[] | null;
}

export interface UpdateProductDto {
  name?: string | null;
  description?: string | null;
  maxUsers?: number;
  maxServices?: number;
  maxTeams?: number;
  features?: string[] | null;
  isActive?: boolean;
}

// Service Management
export interface ServiceResource {
  name: string;
  url: string;
  type: 'api' | 'communication' | 'database' | 'deployment' | 'documentation' | 'monitoring' | 'other' | 'repository' | 'security';
  description?: string;
}

export interface ServiceDto {
  id: string;
  name: string | null;
  description: string | null;
  version: string | null;
  status: ServiceStatus;
  type: ServiceType;
  team: string | null;
  teamId: string;
  resources?: ServiceResource[];
  tags: string[] | null;
  consumers: string[] | null;
  isLocked: boolean;
  createdAt: string;
  updatedAt: string;
  // Optional - only populated when requested
  environments?: ServiceEnvironmentDto[];
}

export interface CreateServiceDto {
  name: string | null;
  description: string | null;
  version: string | null;
  status: ServiceStatus;
  type: ServiceType;
  teamId: string;
  resources?: ServiceResource[];
  tags: string[] | null;
  consumers: string[] | null;
  // Optional: Create environments with the service
  environments?: CreateServiceEnvironmentInput[];
}

export interface CreateServiceEnvironmentInput {
  environmentId: string;
  endpoints: ServiceEndpointDto[];
  healthEndpoint?: string | null;
}

export interface UpdateServiceDto {
  name?: string | null;
  description?: string | null;
  version?: string | null;
  status?: ServiceStatus;
  type?: ServiceType;
  // null = don't update, empty = clear, populated = replace
  resources?: ServiceResource[] | null;
  tags?: string[] | null;
  consumers?: string[] | null;
  // null = don't update, empty = clear all, populated = apply changes
  environments?: UpdateServiceEnvironmentInput[];
}

export interface UpdateServiceEnvironmentInput {
  id?: string | null;  // null = create new, existing = update
  environmentId: string;
  endpoints?: ServiceEndpointDto[];
  healthEndpoint?: string | null;
  delete?: boolean;  // true = delete this environment
}

export interface UpdateServiceRootDto {
  name: string | null;
  description: string | null;
  version: string | null;
  repository: string | null;
  documentation: string | null;
  url: string | null;
  status: ServiceStatus;
  type: ServiceType;
}

// Environment Management
export interface EnvironmentDto {
  id: string;
  name: string | null;
  description: string | null;
  type: EnvironmentType;
  url: string | null;
  status: EnvironmentStatus;
  accountId: string;
  isLocked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEnvironmentDto {
  name: string | null;
  description: string | null;
  type: EnvironmentType;
  url: string | null;
  status: EnvironmentStatus;
}

export interface UpdateEnvironmentDto {
  name: string | null;
  description: string | null;
  type: EnvironmentType;
  url: string | null;
  status: EnvironmentStatus;
}

// Deployment Management
export interface DeploymentDto {
  id: string;
  serviceId: string;
  serviceName: string | null;
  environmentId: string;
  environmentName: string | null;
  accountId: string;
  version: string | null;
  status: DeploymentStatus;
  deployedAt: string;
  deployedBy: string | null;
  commitHash: string | null;
  releaseNotes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDeploymentDto {
  serviceId: string;
  environmentId: string;
  version: string | null;
  deployedBy: string | null;
  commitHash: string | null;
  releaseNotes: string | null;
}

export interface UpdateDeploymentDto {
  status: DeploymentStatus;
  version: string | null;
  commitHash: string | null;
  releaseNotes: string | null;
}

// Health Monitoring
export interface ServiceEndpointDto {
  id: string;
  environment: string;
  type: 'health' | 'logs' | 'metrics' | 'other' | 'service' | 'swagger' | 'version';
  url: string;
  name?: string;
}

// Service Environment (junction between Service + Environment)
export interface ServiceEnvironmentDto {
  id: string;
  serviceId: string;
  environmentId: string;
  serviceName: string;
  environmentName: string;
  endpoints: ServiceEndpointDto[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateServiceEnvironmentDto {
  serviceId: string;
  environmentId: string;
  endpoints: ServiceEndpointDto[];
}

export interface UpdateServiceEnvironmentEndpointsDto {
  endpoints: ServiceEndpointDto[];
}

// Health Check Configuration
export interface ServiceMonitoringConfigurationDto {
  id: string;
  serviceEnvironmentId: string;
  serviceId: string;
  serviceName: string;
  environmentId: string;
  environmentName: string;
  url: string;
  method: HttpMethodType;
  timeoutSeconds: number;
  intervalMinutes: number;
  expectedStatusCode: number;
  expectedResponseBody?: string | null;
  expectedResponseHeader?: string | null;
  authType: ServiceMonitoringAuthType;
  authHeaderName?: string | null;
  authHeaderValue?: string | null;
  retryCount: number;
  retryDelaySeconds: number;
  failureThreshold: number;
  successThreshold: number;
  enableAlerts: boolean;
  alertCooldownMinutes: number;
  isEnabled: boolean;
  lastHealthCheckAt?: string | null;
  currentHealthStatus: ServiceHealthStatus;
  consecutiveHealthFailures: number;
  consecutiveHealthSuccesses: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateServiceMonitoringConfigurationDto {
  serviceEnvironmentId: string;
  url: string;
  method?: HttpMethodType;
  timeoutSeconds?: number;
  intervalMinutes?: number;
  expectedStatusCode?: number;
  expectedResponseBody?: string | null;
  expectedResponseHeader?: string | null;
  authType?: ServiceMonitoringAuthType;
  authHeaderName?: string | null;
  authHeaderValue?: string | null;
  retryCount?: number;
  retryDelaySeconds?: number;
  failureThreshold?: number;
  successThreshold?: number;
  enableAlerts?: boolean;
  alertCooldownMinutes?: number;
}

export interface UpdateServiceMonitoringConfigurationDto {
  url?: string;
  method?: HttpMethodType;
  timeoutSeconds?: number;
  intervalMinutes?: number;
  expectedStatusCode?: number;
  expectedResponseBody?: string | null;
  expectedResponseHeader?: string | null;
  authType?: ServiceMonitoringAuthType;
  authHeaderName?: string | null;
  authHeaderValue?: string | null;
  retryCount?: number;
  retryDelaySeconds?: number;
  failureThreshold?: number;
  successThreshold?: number;
  enableAlerts?: boolean;
  alertCooldownMinutes?: number;
  isEnabled?: boolean;
}

export interface ServiceHealthResultDto {
  id: string;
  serviceMonitoringConfigurationId: string;
  checkedAt: string;
  status: ServiceHealthStatus;
  responseTimeMs: number;
  statusCode: number;
  responseBody?: string | null;
  responseHeaders?: string | null;
  errorMessage?: string | null;
  errorDetails?: string | null;
  agentId?: string | null;
  agentVersion?: string | null;
  checkLocation?: string | null;
  sslValid?: boolean | null;
  sslExpiryDate?: string | null;
  resolvedIpAddress?: string | null;
  dnsResolutionTimeMs?: number | null;
  tcpConnectionTimeMs?: number | null;
  tlsHandshakeTimeMs?: number | null;
  timeToFirstByteMs?: number | null;
  createdAt: string;
}

export interface ServiceMonitoringSummaryDto {
  serviceMonitoringConfigurationId: string;
  serviceName: string;
  environmentName: string;
  currentHealthStatus: ServiceHealthStatus;
  lastHealthCheckAt?: string | null;
  consecutiveHealthFailures: number;
  consecutiveHealthSuccesses: number;
  uptimePercentage: number;
  averageResponseTimeMs: number;
  totalChecks: number;
  successfulChecks: number;
  failedChecks: number;
}

// Incidents
export interface IncidentDto {
  id: string;
  title: string;
  severity: IncidentSeverity;
  status: IncidentStatus;
  startTime: string;
  endTime: string | null;
  description: string;
  serviceId: string | null;
  serviceName: string | null;
  environmentId: string | null;
  environmentName: string | null;
  assignedToUserId: string | null;
  assignedToUserName: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIncidentDto {
  title: string;
  severity: IncidentSeverity;
  description: string;
  serviceId?: string | null;
  environmentId?: string | null;
  assignedToUserId?: string | null;
}

export interface UpdateIncidentDto {
  title?: string | null;
  severity?: IncidentSeverity | null;
  status?: IncidentStatus | null;
  description?: string | null;
  assignedToUserId?: string | null;
  isResolved?: boolean | null;
}

// Teams
export interface TeamLinkDto {
  name: string | null;
  url: string | null;
  type: TeamLinkType;
}

export interface TeamDto {
  id: string;
  name: string | null;
  description: string | null;
  lead: string | null;
  accountId: string;
  members: TeamMemberDto[] | null;
  servicesCount: number;
  email: string | null;
  tags: string[] | null;
  projects: string[] | null;
  links: TeamLinkDto[] | null;
  isLocked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TeamMemberDto {
  name: string | null;
  email: string | null;
  role: string | null;
  avatar: string | null;
}

export interface CreateTeamDto {
  name: string | null;
  description: string | null;
  email: string | null;
  lead: string | null;
  tags: string[] | null;
  projects: string[] | null;
  links: TeamLinkDto[] | null;
  members: TeamMemberDto[] | null;
}

export interface UpdateTeamDto {
  name: string | null;
  description: string | null;
  email: string | null;
  lead: string | null;
  tags: string[] | null;
  projects: string[] | null;
  links: TeamLinkDto[] | null;
  members: TeamMemberDto[] | null;
}

export interface AddTeamMemberDto {
  userId: string;
}

// Pagination
export interface PaginatedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface PaginationParams {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortDescending?: boolean;
}

export interface ServiceDependencyDto {
  id: string;
  serviceId: string;
  serviceName: string;
  dependsOnServiceId: string;
  dependsOnServiceName: string;
  dependencyType: string; // 'sync' | 'async' | 'data'
  isCritical: boolean;
  createdAt: string;
}

export interface CreateServiceDependencyDto {
  serviceId: string;
  dependsOnServiceId: string;
  dependencyType: string;
  isCritical: boolean;
}

export interface UpdateServiceDependencyDto {
  dependencyType?: string;
  isCritical?: boolean;
}

// Referral Management
export interface ReferralInfoDto {
  referralCode: string;
  referredByCode: string | null;
  referralCount: number;
  referralUrl: string;
}

export interface ReferralStatsDto {
  totalReferrals: number;
  activeReferrals: number;
  referredAccounts: ReferredAccountDto[];
}

export interface ReferredAccountDto {
  accountId: string;
  companyName: string;
  email: string;
  createdAt: string;
  isActive: boolean;
}

export interface ValidateReferralCodeDto {
  isValid: boolean;
  referrerCompanyName?: string | null;
  message?: string | null;
}

// Audit Log
export type AuditAction = 
  | 'create' 
  | 'update' 
  | 'delete' 
  | 'deploy' 
  | 'rollback'
  | 'config_change'
  | 'access_granted'
  | 'access_revoked';

export type AuditResource = 'service' | 'environment' | 'team' | 'user' | 'deployment' | 'config';

export interface AuditLogDto {
  id: string;
  timestamp: string;
  userId: string;
  userName: string;
  action: AuditAction;
  resource: AuditResource;
  resourceId: string;
  resourceName: string;
  details: Record<string, any>;
  ipAddress?: string;
  userAgent?: string;
}

export interface AuditFiltersDto {
  userId?: string;
  action?: AuditAction;
  resource?: AuditResource;
  startDate?: string;
  endDate?: string;
  searchTerm?: string;
}

// API Keys
export interface ApiKeyDto {
  id: string;
  name: string;
  keyPrefix: string;
  createdAt: string;
  expiresAt: string | null;
  lastUsedAt: string | null;
}

export interface CreateApiKeyDto {
  name: string;
  expiresAt: string | null;
}

export interface CreateApiKeyResponseDto extends ApiKeyDto {
  key: string;
}
